{
	"pixKeyLabel": "Chave PIX",
	"pixTypeLabel": "Tipo de Chave PIX",
	"pixTypePlaceholder": "Selecione o tipo de Chave PIX",
	"defaultPlaceholder": "Digite a chave PIX",
	"copyPastePlaceholder": "Cole sua chave PIX",
	"placeholders": {
		"phone": "(41) 99999-9999",
		"cpf": "000.000.000-00",
		"cnpj": "00.000.000/0000-00",
		"email": "exemplo@email.com",
		"evp": "Chave aleatória"
	},
	"pixKeyType": {
		"random": "Aleatória",
		"phone": "Telefone",
		"copyPaste": "Copia e Cola"
	},
	"validation": {
		"invalidPixKey": "Chave PIX inválida"
	}
}
